module.exports = __webpack_public_path__ + "img/conclusion6.ef148381.svg";